import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

//helpers
import { BindingCardHelper } from 'src/app/shared/helpers';

//constants
import { RoutesConstants } from 'src/app/shared/constants';

@Injectable()
export class AppGuard implements CanActivate {

  constructor(
    private router: Router
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const bindingCard = BindingCardHelper.bindingCard.value;

    if (!bindingCard) {
      this.router.navigateByUrl(RoutesConstants.WELCOME());
      return false;
    }

    return true;
  }
}
